import { render, staticRenderFns } from "./VideoUploader.vue?vue&type=template&id=065627b0&"
import script from "./VideoUploader.vue?vue&type=script&lang=js&"
export * from "./VideoUploader.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports